<template>
    <div>
        <Teleport to="#contact-form-button">
            <button :class="'button enquire ' + props.retailerType" style="margin-bottom:0" @click="show = true">Email enquiry</button>
        </Teleport>
        <form id="contactform" class="cosmos-form" v-if="show">
            <div class="grid-x  grid-padding-x">
            <div class="cell">
                <h3 style="margin-bottom:1rem">Make an Enquiry</h3>
                <p style="margin-bottom:1rem;">Contact {{ retailer.name }} about your project.</p>
            </div>
                <!--<div class="cell text-center large-text-left" style="margin: 0 2rem"><h1 class="neutral-discerning" style="color:black; display:inline-block">Make an Enquiry</h1></div>-->
                <div id="retailer-search" class="small-12 medium-2 cell">
                    <div style="text-align:center" :class="'entry ' + retailer.type">

                        <figure>
                            <img :src="'/assets/images/map_markers/'+ retailer.type +'.svg'" />
                            <figcaption>
                                <p style="margin-top:1rem;"><span v-html="retailer.typename.split(' ').join('<br>')"></span></p>
                            </figcaption>
                        </figure>

                    </div>
                </div>
                <div class="medium-10 cell">
                
                    <div v-if="!sent" class="grid-x grid-padding-x">
                        <div class="medium-4 cell">
                            <div v-for="(fld, index) in block[0]" class="holder">
                            <p><input :ref="'ins' + index"  :id="fld.fldname" :type="fld.type" :placeholder="fld.placeholder + (fld.required ? '*' : '')" v-model="fld.value" v-on:blur="fld.error = '';" /></p>
                            <p v-if="fld.error" class="error">{{ fld.error }}</p>
                            </div>
                        </div>

                        <div class="medium-8 cell">
                            <div v-for="(fld, index) in block[1]" class="holder">
                                <p><textarea v-if="fld.type == 'textarea'" :id="fld.fldname" :name="fld.fldname" :type="fld.type" :placeholder="fld.placeholder + (fld.required ? '*' : '')" v-model="fld.value" rows="6" :aria-label="fld.placeholder"></textarea></p>
                                <p v-if="fld.error" class="error">{{ fld.error }}</p>
                            </div>
                            <button type="button" :class="'button ' + props.retailerType" @click="send">Submit Enquiry</button>
                            <p class="small">The Alternative Flooring Company Ltd respects your desire for privacy.<br>Data collected on from this form will not be given, sold or shared with any 3rd party organisations.<br>We and your chosen Retail Partner will only use this information to contact you about this enquiry.</p>
                        </div>    

                    </div>
                    <div v-show="sent" class="grid-x">
                        <div id="contactsent" class="cell">
                            <p class="text-center" style="margin-top:3rem;"><b>Thank you, all done!</b><br />We have sent your enquiry on to {{ retailer.name }}.</p>
                        </div>
                    </div>
                </div>
            </div>
        </form>

    </div>
</template>
<script setup>
    import { ref, watch } from 'vue'
    import RendiliCore from '@RendiliCore'
    import { useReCaptcha } from 'vue-recaptcha-v3'

    const props = defineProps([ 'retailer', 'retailerType' ])
    const recaptcha = useReCaptcha()
    const block = ref([
                [
                {'type' : 'text', 'fldname' : 'Firstname', 'placeholder' : 'Firstname', 'required' : true, 'value' : '', 'error' : ''},
                {'type' : 'text', 'fldname' : 'Surname', 'placeholder' : 'Surname', 'required' : true, 'value' : '', 'error' : ''},
                {'type' : 'email', 'fldname' : 'Email', 'placeholder' : 'Email', 'required' : true, 'value' : '', 'error' : ''},
                {'type' : 'text', 'fldname' : 'Phone', 'placeholder' : 'Phone number', 'required' : false, 'value' : '', 'error' : ''},
                {'type' : 'text', 'fldname' : 'Town', 'placeholder' : 'Town / Village', 'required' : true, 'value' : '', 'error' : ''},
            ],
   
            [
                {'type' : 'textarea', 'fldname' : "Message", 'placeholder' : 'How can we help?', 'required' : true, 'value' : '', 'error' : ''}
            ]
            ])
    const sent = ref(false)
    const show = ref(false)

    function updatepostcode(newvalue) {
        block.value[1][0].value = newvalue;
    }
    
    function updateaddress(newvalue) {
        var chosenaddress = newvalue.split("|");
        block.value[1][1].value = chosenaddress[0];
        block.value[1][2].value = chosenaddress[1];
        block.value[1][3].value = chosenaddress[2];
        block.value[1][4].value = chosenaddress[3];
        block.value[1][5].value = chosenaddress[4];
    }

    function validate(_callback){
        var valid = true;
        block.value.forEach(function (block, index) {
            block.forEach(function (fld, i) {
                if(fld.type == 'email') {
                    if(!validateEmail(fld.value)) {
                        fld.error = 'Invalid Email Address';
                        valid = false;
                    }
                }                        
                else if(fld.required && !fld.value) {
                    fld.error = 'This is a required field';
                    valid = false;
                } 
                else {
                    fld.error = '';
                }
            });
        });
        _callback(valid);
    }

    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function submitform(recaptchaResponse) {
            var vm = this;
            validate(function(valid) {
                //post form
                if(valid) {
                    var formdata = {};
                    vm.block.forEach(function (block, index) {
                        block.forEach(function (fld, i) {
                            formdata[fld.fldname] = fld.value;
                        });
                    });
                    formdata['Retailer'] = vm.retailer.id;
                    formdata['g-recaptcha-response'] = recaptchaResponse;
                    RendiliCore.Json.PostJsonData({
                        url: '/alternative/site/contactRetailer',
                        data: formdata
                    }).then(function(data) {
                        if (data.result == 'ok') {
                            vm.sent = true;
                            document.getElementById('contactsent').scrollIntoView();
                        } else {
                            alert(data.message);
                            vm.$refs.recaptcha.reset();
                        }
                    }, function() {
                        vm.$refs.recaptcha.reset();
                    });
                } else {
                    vm.$refs.recaptcha.reset();
                }
            });
        }


    function close(event) {
        event.preventDefault();
        this.$emit('closeform');
    }

    watch(() => props.retailer, () => {
        sent.value = false
    })

    async function send() {
        validate(async (canSend) => {
            if (canSend) {
                await recaptcha.recaptchaLoaded()
                const token = await recaptcha.executeRecaptcha('login')

                var formdata = {}
                block.value.forEach((block, index) => {
                    block.forEach((fld, i) => {
                        formdata[fld.fldname] = fld.value
                    })
                })
                formdata['Retailer'] = props.retailer.id
                formdata['g-recaptcha-response'] = token
                RendiliCore.Json.PostJsonData({
                    url: '/alternative/site/contactRetailer',
                    data: formdata
                }).then((data) => {
                    if (data.result == 'ok') {
                        sent.value = true;
                        document.getElementById('contactsent').scrollIntoView();
                    }
                })
            } else {
                showValidation.value = true
            }
        })
    }

    defineOptions({
        name: 'Retailer Contact Form'
    })
</script>